import { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Modal } from "antd";
import { get } from "../../../services/ApiService";

const CATEGORY_LABELS = {
  OpenGsl: "Open GSL",
  OpenPendingPmed: "Open Pending P",
  OpenDispatchedPmed: "Open Complete P",
};

const categoryLabel = (code) => CATEGORY_LABELS[code] || "another category";

const UnreadQueueNav = ({ orderId }) => {
  const navigate = useNavigate();
  const [queue, setQueue] = useState(null);
  const [loading, setLoading] = useState(false);

  const load = useCallback(async () => {
    if (!orderId) return;
    try {
      setLoading(true);
      const res = await get(`api/messages/unread-queue?currentOrderId=${orderId}`);
      if (res?.success) setQueue(res);
    } catch (error) {
      console.error("Failed to load unread queue", error);
    } finally {
      setLoading(false);
    }
  }, [orderId]);

  useEffect(() => {
    load();
  }, [load]);

  const go = (neighbour) => {
    if (!neighbour?.orderId) return;
    const navigateTo = () => navigate(`/orders/${neighbour.orderId}`);

    if (neighbour.crossesBoundary) {
      Modal.confirm({
        title: "Switch category?",
        content: queue?.position
          ? `You've reached the end of this category. Switch to ${categoryLabel(
              neighbour.category
            )}?`
          : `Go to unread messages in ${categoryLabel(neighbour.category)}?`,
        okText: "Switch",
        cancelText: "Stay",
        onOk: navigateTo,
      });
    } else {
      navigateTo();
    }
  };

  if (!orderId || !queue) return null;

  const { total, position, currentCategory, next, prev } = queue;

  return (
    <div className="unread-queue-nav">
      <button
        type="button"
        className="unread-queue-nav__btn"
        disabled={loading || !prev}
        onClick={() => go(prev)}
      >
        <i className="fas fa-arrow-left" aria-hidden="true" />
        <span>Previous</span>
      </button>

      <span className="unread-queue-nav__status">
        {total === 0 ? (
          "No unread messages"
        ) : (
          <>
            <span className="unread-queue-nav__count">
              {position ? `${position} / ${total}` : total}
            </span>
            {currentCategory && (
              <span className="unread-queue-nav__cat">{categoryLabel(currentCategory)}</span>
            )}
          </>
        )}
      </span>

      <button
        type="button"
        className="unread-queue-nav__btn"
        disabled={loading || !next}
        onClick={() => go(next)}
      >
        <span>Next</span>
        <i className="fas fa-arrow-right" aria-hidden="true" />
      </button>
    </div>
  );
};

export default UnreadQueueNav;
